class GetRainfallSinceFirstLogUseCase {
  constructor(repository) {
    this.repository = repository;
  }
  async execute(START){
    const result= await this.repository.getRainfallSinceFirstLog(START)
    return result && result.length?result[0]:[];
  }
}
export {
  GetRainfallSinceFirstLogUseCase,
};
